import { Injectable } from '@angular/core';
import {CheckerMode} from '../components/config-checker/config-checker.component';
import {BehaviorSubject} from 'rxjs';


export interface CheckerSettings{
  checkerMode: CheckerMode;
  onlyChanged: boolean;
  onlyRendered: boolean;
  onlyNewPages: boolean;
  onlyReachedPages: boolean;
  onlyDeadEnds: boolean;
  enableComparison: boolean;
  enableMetricOverviewPage: boolean;
  enableMetricInfoPage: boolean;
  designTag: string;
  defaultDesignTag: string;
  viewMode: boolean;
  selectedAppPath?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CheckerDataService {
  isCheckerActive = false;
  // init home page instance
  private homePageInstance: any;

  // init config checker settings
  private settingsSubject = new BehaviorSubject<CheckerSettings | null>(null);

  // home-page-related functions
  setHomePage(instance: any) {
    this.homePageInstance = instance;
  }

  getHomePage() {
    return this.homePageInstance;
  }

  // settings related functions
  setSettings(settings: CheckerSettings) {
    this.settingsSubject.next(settings);
  }

  getSettings() {
    return this.settingsSubject.getValue();
  }


}
